// nodes/textNode.js - Part 3: Enhanced with dynamic handles
import { useState, useEffect } from "react";
import { BaseNode } from "../baseNode";
import { nodeConfigs } from "../nodeConfigs";

export const TextNode = ({ id, data }) => {
  const [dynamicInputs, setDynamicInputs] = useState([]);

  useEffect(() => {
    // Part 3: Extract variables from text
    const text = data.text || "";
    const variableRegex = /\{\{\s*(\w+)\s*\}\}/g;
    const matches = [...text.matchAll(variableRegex)];
    const variables = [...new Set(matches.map((m) => m[1]))];

    setDynamicInputs(variables.map((v) => ({ id: v })));
  }, [data.text]);

  const enhancedConfig = {
    ...nodeConfigs.text,
    inputs: dynamicInputs,
  };

  return <BaseNode id={id} data={data} config={enhancedConfig} />;
};
